import * as types from '../constants/ActionTypes-privilegePartyMember';


export const setPrivilegePartyMembers = itemsPartyMember => ({
  type: types.SET_ELEMENT_PARTY_MEMBER,
  payload: itemsPartyMember,
  reducer_type: 'reducer_privilege'
});
  
